import PropTypes from 'prop-types';

export const currentUserType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  analyticsId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired
});

export const currentProjectEntitlementsType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  accountName: PropTypes.string.isRequired,
  projectScope: PropTypes.arrayOf(PropTypes.string).isRequired,
  containers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    })
  ).isRequired
});

export const roleType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  oxygenId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

export const companyType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  oxygenId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

export const oxygenUserType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  oxygenId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  projectStatus: PropTypes.string.isRequired,
  profileImg50: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  isProjectAdmin: PropTypes.bool.isRequired,
  company: companyType.isRequired,
  roles: PropTypes.arrayOf(roleType).isRequired
});
